import { Stack, Typography } from '@mui/material';
import React from 'react';

import { DeleteIcon } from '@/shared/assets/icons/delete-icon';
import { Alert } from '@/shared/components/ui/alert/alert';
import { IconButton } from '@/shared/components/ui/button/icon-button/icon-button';
import { SelectedItemContainer } from '@/shared/components/ui/selected-items-list/components/selected-item/selected-item.styled';
import { TSelectedItem } from '@/shared/components/ui/selected-items-list/components/selected-item/selected-item.types';
import { TruncatedText } from '@/shared/components/ui/truncated-text/truncated-text';

export const SelectedItem: React.FC<TSelectedItem> = ({
  name,
  icon,
  onDelete,
  actions,
  hint,
  variant,
  error,
  fullWidth,
  sizeVariant = 'default',
}) => {
  const renderName = () => {
    if (typeof name === 'string') {
      return <TruncatedText text={name} maxLength={40} variant="p5" />;
    }

    return name;
  };

  return (
    <Stack gap={hint ? '0.5rem' : 0}>
      <SelectedItemContainer $variant={variant} $sizeVariant={sizeVariant}>
        <Stack
          direction="row"
          gap="0.5rem"
          alignItems="center"
          width={fullWidth ? '100%' : 'initial'}
        >
          {icon}
          {renderName()}
        </Stack>
        <Stack direction="row" gap="0.5rem" alignItems="center">
          {actions && actions}
          {onDelete && (
            <IconButton onClick={onDelete}>
              <DeleteIcon />
            </IconButton>
          )}
        </Stack>
      </SelectedItemContainer>
      {hint && <Alert text={hint} color="blue" />}
      {error && (
        <Typography
          marginTop="0.5rem"
          marginLeft="0.5rem"
          variant="p8"
          color="status.red.text"
        >
          {error}
        </Typography>
      )}
    </Stack>
  );
};
